import { Component } from "react"
import PropTypes from "prop-types"

import PopulatorInput from "partners/components/shared/field_type_inputs/populator_input"
import InlineErrors from "shared/components/inline_errors"

class CustomFieldCheckboxMultiField extends Component {
  componentDidUpdate(prevProps) {
    if (
      prevProps.hasDefaultValue != this.props.hasDefaultValue &&
      !this.props.hasDefaultValue
    ) {
      this.props.onDefaultValueChange(null)
    }
  }

  handleDefaultValueChange = value => {
    return e => {
      const defaultValue = this.props.defaultValue
      if (e.target.checked) {
        this.props.onDefaultValueChange(defaultValue.concat(value))
      } else {
        this.props.onDefaultValueChange(defaultValue.filter(v => v !== value))
      }
    }
  }

  render() {
    const populator = this.props.populator || []
    const { defaultValue, errors } = this.props

    return (
      <>
        {errors?.populator && errors.populator.length > 0 && (
          <InlineErrors errors={errors["populator"]} />
        )}

        <PopulatorInput
          populator={populator}
          onPopulatorChange={this.props.onPopulatorChange}
          disabled={this.props.disabled}
        />

        {this.props.hasDefaultValue && (
          <div className="field">
            <div className="label">
              <label>Default value(s)</label>
            </div>
            <div className="input">
              {errors?.hasDefaultValue && errors.hasDefaultValue.length > 0 && (
                <InlineErrors errors={errors["hasDefaultValue"]} />
              )}
              {populator.map((o, i) => {
                return (
                  <div key={i} className="input">
                    <label className="checkbox">
                      <input
                        type="checkbox"
                        checked={defaultValue.includes(o.value)}
                        disabled={this.props.disabled}
                        onChange={this.handleDefaultValueChange(o.value)}
                      />
                      <span />
                      <span>
                        <span className="checkbox-body">{o.label}</span>
                      </span>
                    </label>
                  </div>
                )
              })}
            </div>
          </div>
        )}
      </>
    )
  }
}

CustomFieldCheckboxMultiField.propTypes = {
  populator: PropTypes.array,
  onPopulatorChange: PropTypes.func.isRequired,
  defaultValue: PropTypes.arrayOf(PropTypes.string),
  hasDefaultValue: PropTypes.bool,
  onDefaultValueChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  errors: PropTypes.object,
  fieldType: PropTypes.string,
}

export default CustomFieldCheckboxMultiField
